import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_unavailable_page_message]: 'This page is temporarily unavailable.{lineBreak} We apologize for the inconvenience and ask that you try again later.',
  [StringId.DV_DP_only_playback_available_in_gen4_message]: 'We are currently experiencing some problems with this live event. Hopefully, you can still watch the event, while we are trying to solve the problem.',
}